import { create } from 'zustand';
import { getMePlanning } from '@/api/generated/me-planning/me-planning';
import type { FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto as PlanningEntryListDto } from '@/api/generated/models';

const mePlanningApi = getMePlanning();

interface MyPlanState {
  entries: PlanningEntryListDto[];
  loading: boolean;
  error: string | null;
  currentDate: string;
  fetchMyPlan: (from: string, to: string) => Promise<void>;
  setCurrentDate: (date: string) => void;
  clearError: () => void;
}

function todayString(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export const useMyPlanStore = create<MyPlanState>((set) => ({
  entries: [],
  loading: false,
  error: null,
  currentDate: todayString(),

  fetchMyPlan: async (from, to) => {
    set({ loading: true, error: null });
    try {
      const data = await mePlanningApi.getApiV1MePlanning({ from, to });
      set({ entries: data ?? [] });
    } catch {
      set({ error: 'errors.fetchFailed' });
    } finally {
      set({ loading: false });
    }
  },

  setCurrentDate: (date) => set({ currentDate: date }),
  clearError: () => set({ error: null }),
}));
